export default "__VITE_ASSET__5dfe4b3b__"